var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8005 6.12907C14.0666 5.87078 14.0666 5.45201 13.8005 5.19372C13.5343 4.93543 13.1028 4.93543 12.8367 5.19372L8.49963 9.4029L4.16337 5.1945C3.89723 4.93621 3.46574 4.93621 3.1996 5.1945C2.93347 5.45279 2.93347 5.87156 3.1996 6.12985L8.01844 10.8066C8.28457 11.0649 8.71607 11.0649 8.9822 10.8066C8.99095 10.7981 8.99941 10.7894 9.00758 10.7806L13.8005 6.12907Z",
    fill: "#7D899D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/arrowdown.ca8dcf5f.svg";
export { ForwardRef as ReactComponent };